import { SpringshareHoursCalendar } from "design-system/sites/baker/hours-calendar/springshare-hours-calendar";
import { HoursCalendarEntry } from "frontend/contentful/schema/blocks";
import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { useFetch } from "frontend/hooks/use-fetch";
import { useState } from "react";

interface CalendarAPIResponse {
  result: string;
}

export const ContentfulHoursCalendar =
  createContentfulComponent<HoursCalendarEntry>(({ entry }) => {
    const [date, setDate] = useState(
      new Date().toLocaleDateString("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        timeZone: "America/New_York",
      }),
    );

    if (!entry.fields.title) {
      return;
    }

    const { data } = useFetch<CalendarAPIResponse>({
      url: "/api/hours/calendar",
      params: { date },
    });

    if (!data?.result) {
      return;
    }

    function setDateWeek(dateString: string, direction: "previous" | "next") {
      const date = new Date(dateString);

      if (direction === "previous") {
        date.setDate(date.getDate() - 7);
      } else if (direction === "next") {
        date.setDate(date.getDate() + 7);
      }

      const newDate = date.toISOString().split("T")[0];
      newDate && setDate(newDate);
    }

    return (
      <SpringshareHoursCalendar
        title={entry.fields.title}
        tableHTML={data.result}
        onClickPrevious={() => setDateWeek(date, "previous")}
        onClickNext={() => setDateWeek(date, "next")}
      />
    );
  });
